import React from "react";
import { Box, Typography, IconButton, Grid2 } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

interface CheckInOutDetailProps {
  type: "checkin" | "checkout";
  label?: string;
  activeTime: string;
  location: {
    latitude: number;
    longitude: number;
  };
  note?: string;
  images?: string[];
  isDistanceExceeded?: boolean;
  onImageClick: (image: string) => void;
}

const CheckInOutDetail: React.FC<CheckInOutDetailProps> = ({
  type,
  label,
  activeTime,
  location,
  note,
  images,
  isDistanceExceeded,
  onImageClick,
}) => {
  const formatDateWithTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString("th-TH", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, mb: 2 }}>
      <Grid2
        container
        direction={"row"}
        size={{ xs: 12, sm: 12 }}
        sx={{ mb: 2, justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
          {label ? label : type === "checkin" ? "เข้างาน" : "ออกงาน"}{" "}
          {isDistanceExceeded !== undefined && (
            <Typography
              component="span"
              sx={{
                color: isDistanceExceeded ? "custom.red" : "custom.green",
                fontWeight: 300,
              }}
            >
              ({isDistanceExceeded ? "อยู่นอกบริเวณ" : "อยู่ในบริเวณ"})
            </Typography>
          )}
        </Typography>
        <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 300 }}>
            เวลาเข้างาน:{" "}
            {
              <Typography
                component="span"
                variant="body2"
                sx={{ fontWeight: 500 }}
              >
                {formatDateWithTime(activeTime)}
              </Typography>
            }
          </Typography>
        </Box>
      </Grid2>
      <Typography variant="body2" sx={{ mb: 1, fontWeight: 300 }}>
        ภาพประกอบ
      </Typography>
      <Grid2 container spacing={2} direction={"row"}>
        <Grid2 size={{ xs: 12, sm: 4 }}>
          {images?.map((image, imgIndex) => (
            <Box
              key={`${type}-image-${imgIndex}`}
              component="img"
              src={image}
              alt={`${type === "checkin" ? "เข้างาน" : "ออกงาน"} รูปที่ ${
                imgIndex + 1
              }`}
              sx={{
                width: "100%",
                aspectRatio: "3/4",
                objectFit: "cover",
                borderRadius: 2,
                cursor: "pointer",
                "&:hover": {
                  opacity: 0.8,
                },
              }}
              onClick={() => onImageClick(image)}
            />
          ))}
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 8 }}>
          <Grid2
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 300 }}>
              ตำแหน่ง
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                window.open(
                  `https://www.google.com/maps?q=${location.latitude},${location.longitude}`,
                  "_blank"
                );
              }}
            >
              <LocationOnIcon color="primary" />
            </IconButton>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12 }} sx={{ mb: 4 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 300, cursor: "pointer" }}
              onClick={() => {
                window.open(
                  `https://www.google.com/maps?q=${location.latitude},${location.longitude}`,
                  "_blank"
                );
              }}
            >
              {location.latitude}, {location.longitude}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }} sx={{ mb: 1 }}>
            <Typography variant="body1" sx={{ fontWeight: 300 }}>
              หมายเหตุ
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                wordWrap: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
            >
              {note ? note : "-"}
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>{" "}
    </Box>
  );
};

export default CheckInOutDetail;
